module.exports = __webpack_public_path__ + "static/media/Logo_karma.a34b940f.png";